export default "__VITE_ASSET__BuUk8VpP__"